const LoadingSpinner = () => {
    return (
      <div className="flex items-center justify-center space-x-2">
        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        <span className="text-lg font-medium text-gray-700 dark:text-gray-300">Loading...</span>
      </div>
    );
  };
  
  export default LoadingSpinner;